import { infoThirdUserSelf,qqLogout } from '@/api/user'

const state = {
  token: '',
  userInfo: {
    avatar: '',
    nickname: '',
    userId: '', 
  }
}

const mutations = {
  SET_TOKEN: (state,token)=>{
    if (token === ''){
      $cookies.remove("token");
    }else{
      $cookies.set("token",token);
    }
    state.token = token;
  },
  SET_USERINFO: (state,userInfo)=>{
    state.userInfo = userInfo
  },
  CLEAR_USER(state) {
      $cookies.remove("token");
      state.token = ''
      state.userInfo = {
        avatar: '',
        nickname: '',
        userId: '', 
      }
    }
}

const actions = {

  async getUserInfo({commit}){
    return new Promise((resolve,reject)=>{
        infoThirdUserSelf().then(response=>{
          const userInfo = response.data;
          const userTmp = {
            avatar: userInfo.avatar,
            nickname: userInfo.nickname,
            userId: userInfo.userId, 
          }
          commit('SET_USERINFO',userTmp);
          resolve();
        }).catch(error => {reject(error)})
    })
  },

  qqLogout({commit}){
    return new Promise((resolve, reject) => {
      qqLogout().then(response => {
        commit('CLEAR_USER');
        resolve();
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js